export default __webpack_public_path__ + "static/accessibility-725e9178cec9646245b4573375bf0d2f.png";